import { useNavigate } from "react-router-dom";
import { UseforgetPassword } from "../../actions/authActions";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { useForm } from "react-hook-form";
import textWeight from "../../utils/textWeight";

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loadingToapi, setLoadingToapi] = useState();
  const { TextWeight } = textWeight();
  // Set up react-hook-form
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      otpemail: "",
    },
  });

  const sendOtp = UseforgetPassword(setLoadingToapi, navigate);
  // Handle form submission
  const onSubmit = (data) => {
    setLoadingToapi(true);
    sendOtp.mutate({
      email: data.otpemail,
    });
    dispatch({
      type: "SEND_EMIAL_OTP_DATA",
      payload: { emailOTPData: data.otpemail },
    });
  };
  return {
    navigate,
    loadingToapi,
    errors,
    setValue,
    handleSubmit,
    onSubmit,
    register,
    TextWeight,
  };
};
